import { useViewport } from '@travelata-libs/utils';
import Vue from 'vue';

export function validateRequiredCheckboxes(viewModel, requiredKeys, container = document) {
  let valid = true;
  requiredKeys.forEach((key) => {
    if (key === 'agreeAdvertising' && viewModel.get('advertisingConsentLocked')) return;
    const label = container.querySelector(`[data-checkbox="${key}"]`);
    const icon = label ? label.querySelector('.checkbox-item-common__icon') : null;
    if (!viewModel.get(key)) {
      if (icon) icon.classList.add('checkbox-error');
      valid = false;
    } else if (icon) icon.classList.remove('checkbox-error');
  });
  return valid;
}

export function getCheckboxConfigs(viewModel, idPrefix = '') {
    const advertisingConsentLocked = viewModel.get('advertisingConsentLocked');
	const { isMobile } = useViewport();
	return [
		{
			id: `${idPrefix}agreeUserAgreement`,
			modelKey: 'agreeUserAgreement',
			labelVNode: (h) => h('span', [
				'Я принимаю ',
				h('a', {
					attrs: {
						href: '/user-agreement.html',
						target: '_blank',
						class: 'link'
					}
				}, 'Пользовательское соглашение'),
				' и ',
				h('a', {
					attrs: {
						href: '/privacy.html',
						target: '_blank',
						class: 'link'
					}
				}, 'Политику о персональных данных')
			]),
			disabled: false,
		},
		{
			id: `${idPrefix}agreePersonalData`,
			modelKey: 'agreePersonalData',
			labelVNode: (h) => h('span', [
				'Я даю ',
				h('a', {
					attrs: {
						href: '/personal-data-agreement.html',
						target: '_blank',
						class: 'link'
					}
				}, 'согласие на обработку персональных данных')
			]),
			disabled: false,
		},
		{
			id: `${idPrefix}agreeAdvertising`,
			modelKey: 'agreeAdvertising',
			labelVNode: (h) => advertisingConsentLocked
				? h('span', [
					h('a', {
						attrs: {
							href: '/consent-to-advertising',
							target: '_blank',
							class: 'link'
						}}, 'Согласие на получение рекламных сообщений'),
					h('span', {class: {
						'checkbox-item-common__text-locked-secondary': true,
						'checkbox-item-common-mobile__text-locked-secondary': isMobile.value
					}}, ' предоставлено ранее'),
				])
				: h('span', [
					'Я даю ',
					h('a', {
						attrs: {
							href: '/consent-to-advertising',
							target: '_blank',
							class: 'link'
						}
					}, 'согласие на получение рекламных сообщений')
				]),
			disabled: advertisingConsentLocked,
			locked: advertisingConsentLocked,
			iconLocked: advertisingConsentLocked,
		},
		{
			id: `${idPrefix}agreeDisseminationAndPersonalData`,
			modelKey: 'agreeDisseminationAndPersonalData',
			labelVNode: (h) => h('span', [
				'Даю ',
				h('a', {
					attrs: {
						href: '/personal-data-agreement.html',
						target: '_blank',
						class: 'link'
					}
				}, 'согласие на обработку'),
				' и ',
				h('a', {
					attrs: {
						href: '/personal-data-transfer-consent.html',
						target: '_blank',
						class: 'link'
					}
				}, 'распространение персональных данных ')
			]),
			disabled: false,
		},
	];
}

export function mountCheckboxes(checkboxConfigs, viewModel, CheckBoxInputCommon, container = document) {
    checkboxConfigs.forEach(checkboxConfig => {
        const el = container.querySelector(`#${checkboxConfig.id}`);
        if (el) {
            if (el.__vueInstance) {
                el.__vueInstance.$destroy();
                el.__vueInstance = null;
            }
            el.innerHTML = '';
            el.__vueInstance = new Vue({
                render: h => h(CheckBoxInputCommon, {
                    props: {
                        isChecked: viewModel.get(checkboxConfig.modelKey),
                        value: true,
                        disabled: checkboxConfig.disabled,
                        isAuthOrRegistration: true,
                        checkboxKey: checkboxConfig.modelKey,
                        domId: checkboxConfig.id,
                        iconLocked: checkboxConfig.iconLocked,
                        labelClass: checkboxConfig.labelClass ?? '',
                    },
                    on: {
                        selected: ({ checked }) => {
                            viewModel.set(checkboxConfig.modelKey, checked);
                        }
                    }
                }, checkboxConfig.labelVNode ? [checkboxConfig.labelVNode(h)] : undefined),
            }).$mount(el);
        }
    });
}

let lastCheckedEmail = '';
let debounceTimeout = null;

export function fetchAndSyncAdvertisingConsent({
    email,
    consentModel,
    getCheckboxConfigs,
    mountCheckboxes,
    CheckBoxInputCommon,
    onComplete
}) {
    if (email === lastCheckedEmail) return;
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(async () => {
        lastCheckedEmail = email;
        const url = (window.appConfig.apiGatewayUrl) + '/frontend/subscriptions/contacts/getByEmail';
        let result = null;
        try {
            const response = await $.ajax({
                url,
                type: 'GET',
                data: { email },
            });
            if (response.success && response.result) {
                consentModel.set('advertisingConsentLocked', !!response.result.agreedWithPolicy);
                consentModel.set('agreeAdvertising', !!response.result.agreedWithPolicy);
                result = response.result;
            } else {
                consentModel.set('advertisingConsentLocked', false);
                consentModel.set('agreeAdvertising', false);
            }
        } catch {
            consentModel.set('advertisingConsentLocked', false);
            consentModel.set('agreeAdvertising', false);
        } finally {
            const checkboxConfigs = getCheckboxConfigs(consentModel, 'checkbox-');
            mountCheckboxes(checkboxConfigs, consentModel, CheckBoxInputCommon);
            if (typeof onComplete === 'function') onComplete(result);
        }
    }, 300);
}